module.exports = __webpack_public_path__ + "media/images/realty-one-group-color-large-logo-dedc8aec.png";